import { Stack, TextField, Typography } from "@mui/material";
import { Markdown } from "@/app/features/shared/markdown/Markdown";
import MarkdownEditor from "@/app/features/shared/editable-markdown/MarkdownEditor";
import { useShowroom } from "@/app/__to_be_integrated/_____components/showroom/ShowroomContext";

export default function TextView() {
    const {
        content,
        isEditing,
        setTitle,
        setSubtitle,
        setDescription,
    } = useShowroom();

    if (isEditing) {
        return (
            <>
                <Stack spacing={2} className="w-full" >
                    <TextField value={content.title} label="Titel" onChange={(event) => setTitle(event.target.value) } />
                    <TextField value={content.subtitle} label="Untertitel" onChange={(event) => setSubtitle(event.target.value) } />
                    <MarkdownEditor
                        label="Beschreibung"
                        typographyOverrides={{ paragraph: "body2" }}
                        value={content.description || ''}
                        onChange={(value) => setDescription(value || '')}
                    />
                </Stack>
            </>
        )
    } else {
        return (
            <Stack spacing={2} className="w-full">
                <Stack spacing={1}>
                    {content.title && (
                        <Typography variant="h2" textAlign="center">{content.title}</Typography>
                    )}
                    {content.subtitle && <Typography variant="subtitle2" textAlign="center">{content.subtitle}</Typography>}
                </Stack>
                {content.description && <Markdown typographyOverrides={{ paragraph: "body2" }} value={content.description} />}
            </Stack>
        )
    }
}
